<template>
    <FormInputContainer class="FormStripeCard" :inputId="`I${_uid}`" :label="label">
        <div ref="cardMount"></div>
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormStripeCard',

    components: { FormInputContainer },

    props: {
        label: { type: String, default: 'Credit Card' },
    },

    data: () => ({
        card: null,
    }),

    mounted() {
        const style = { base: { fontSize: '16px', lineHeight: '40px' } };
        this.card = this.$stripe.elements().create('card', { style, hidePostalCode: true });

        this.card.mount(this.$refs.cardMount);
        this.$emit('input', this.card);
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.FormStripeCard {
    .StripeElement {
        @extend %form-control;
    }
}
</style>
